export default "__VITE_ASSET__B3w5fU3R__"